import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import { Navbar as BootstrapNavbar } from 'react-bootstrap'; 
import logo from '../photos/logo.png';
import '../styles/Navbar.css';

function Navbar() {
    return (
        <BootstrapNavbar expand="lg" bg="light" fixed="top">
            <Container>
                <BootstrapNavbar.Brand href="#hero">
                    <img src={logo} alt="Logo" className="logo" />
                </BootstrapNavbar.Brand>
                <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
                <BootstrapNavbar.Collapse id="basic-navbar-nav">
                    <Nav className="ml-auto">
                        <Nav.Link href="#hero" className='links'>الرئيسية</Nav.Link>
                        <Nav.Link href="#about" className='links'>تعرف علينا </Nav.Link>
                        <Nav.Link href="#products" className='links'>منتجاتنا</Nav.Link>
                        <Nav.Link href="#contact" className='links'>اتصل بنا</Nav.Link>
                    </Nav>
                </BootstrapNavbar.Collapse>
            </Container>
        </BootstrapNavbar>
    );
}

export default Navbar;
